var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 10.125H18.4655L14.625 6.28454C14.4167 6.07482 14.1689 5.90854 13.8959 5.79532C13.6229 5.68211 13.3301 5.62422 13.0345 5.62501H5.625C5.02826 5.62501 4.45597 5.86206 4.03401 6.28402C3.61205 6.70597 3.375 7.27827 3.375 7.87501V28.2122C3.37612 28.7857 3.60453 29.3354 4.0102 29.7408C4.41587 30.1462 4.9657 30.3743 5.53922 30.375H30.5002C31.0635 30.3743 31.6035 30.1502 32.0018 29.7518C32.4002 29.3535 32.6243 28.8135 32.625 28.2502V12.375C32.625 11.7783 32.3879 11.206 31.966 10.784C31.544 10.3621 30.9717 10.125 30.375 10.125ZM5.625 7.87501H13.0345L15.2845 10.125H5.625V7.87501Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.4bc0e127affb9d86b6916220fd79dc86.svg";
export { ForwardRef as ReactComponent };